import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const HifiSection: FunctionComponent = () => {
	const {t} = useTranslation();

	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'featureslandingpage_title_elevatemusicwithhifisound_standalone-web',
							{ns: 'features'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_elevatemusicwithhifisound_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					src="eb40c33a17808f047c69b5aedb6887f8.png"
					aspectRatio="2880/840"
					alt={t('metatag_text_highfidelitymusic_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'offers'}}
					href="/features/hifi"
				>
					{t('generic_action_discovermore_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
